import { render, staticRenderFns } from "./CatAndSearchTerms.vue?vue&type=template&id=6d233708&scoped=true"
import script from "./CatAndSearchTerms.vue?vue&type=script&lang=js"
export * from "./CatAndSearchTerms.vue?vue&type=script&lang=js"
import style0 from "./CatAndSearchTerms.vue?vue&type=style&index=0&id=6d233708&prod&scoped=true&lang=css"
import style1 from "./CatAndSearchTerms.vue?vue&type=style&index=1&id=6d233708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d233708",
  null
  
)

export default component.exports